import React, { useState, useEffect } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { toast } from "react-toastify";
import ApiServices from "../../api/ApiServices";
import axios from "axios";
import { handleError } from "../../components/utils/AuthenticationCheck";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import AxiosApiCall from "../../api/AxiosApiCall";
import { ReactComponent as PencilFill } from "bootstrap-icons/icons/pencil-fill.svg";


const UpdateAppSettings = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // const sett = location.state?.sett;
    const settings = location.state?.settings;
    // console.log("this is the app setting key", settings);

    const [id, setId] = useState("");
    const [about, setAbout] = useState("");
    const [address, setAddress] = useState("");
    const [email, setEmail] = useState("");
    const [phone_number, setPhoneNumber] = useState("");
    const [site_title, setSiteTitle] = useState("");
    const [whatsapp_number, setWhatsappNumber] = useState("");

    const [name, setName] = useState("");
    const [value, setValue] = useState("");
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        if (settings) {
            // console.log("this is the app setting", sett);
            setId(settings.id || "");
            setAbout(settings.about || "");
            setAddress(settings.address || "");
            setEmail(settings.email || "");
            setPhoneNumber(settings.phone_number || "");
            setSiteTitle(settings.site_title || "");
            setWhatsappNumber(settings.whatsapp_number || "");
        }
    }, [settings]);


    // Validation function
    const validateForm = () => {
        if (!about || !email || !phone_number || !site_title || !whatsapp_number || !address) {
            toast.error("All fields are required.");
            return false;
        }
        return true;
    };

    // The biggest marketplace managed by Joatech Technologies, which provides various kinds of daily needs and hobbies
    //axios api encryption call
    const axios = AxiosApiCall();

    const handleUpdate = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setLoading(true);

        const formData = {
            site_title,
            about,
            phone_number,
            email,
            whatsapp_number,
            address,
        };
        // if (name) formData[name] = value;

        // console.log("update the app settings here", formData);

        try {
            const authData = JSON.parse(localStorage.getItem("auth"));
            const token = authData?.token;
            if (!token) {
                throw new Error("No access token found.");
            }

            const response = await axios.put(
                ApiServices.UpdateAppSettings,
                // formData,
                { site_title, about, phone_number, email, whatsapp_number, address },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                }
            );

            const { status, message } = response.data;
            if (status === 200) {
                navigate("/admin/appsettings/list");
                toast.success(message, { toastId: "appsettings-update-success" });
                setName("");
                setEmail("");
                setAbout("");
                setAddress("");
                setPhoneNumber("");
                setSiteTitle("");
                setWhatsappNumber("");

            } else {
                handleError({ response: { status, data: { message } } }, navigate);
            }
        } catch (error) {
            handleError(error, navigate);
        } finally {
            setLoading(false);
        }
    };

    // Fields that should use a textarea
    // const textareaFields = ["address", "about us"];

    return (
        <div>
            <MainLayouts>
                <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                    <section
                        className="w-full  pr-[3%] pt-3 my-3"
                        style={{ backgroundColor: "#F7F7F7" }}
                    >
                        <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                            <ol className="list-none p-0 inline-flex mb-2">
                                <li className="flex items-center">
                                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                        Product Property
                                    </p>
                                    <ChevronRightIcon />
                                </li>
                                <li className="flex items-center">
                                    <p className="text-orange1">Update</p>
                                </li>
                            </ol>
                        </nav>

                    </section>

                    <section className="gray_background">
                        <div className="container px-1 pb-2 mx-auto">
                            <div className="lg:w-full md:w-1/2 bg-white rounded-lg py-3 px-2 flex flex-col md:ml-auto w-full mt-10 md:mt-0 relative z-10 shadow-md bg-dGrey3">
                                <form onSubmit={handleUpdate} >
                                    <input type="hidden" name="id" value={id} />

                                    <div className="flex">
                                        <div className="w-3/5 mx-1 mb-2">
                                            <label htmlFor="name" className="block text-sm font-medium text-gray-700">Site Title</label>
                                            <input
                                                type="text"
                                                id="name"
                                                name="name"
                                                value={site_title}
                                                onChange={(e) => setSiteTitle(e.target.value)}
                                                className="border border-grey3 p-2 rounded-md w-full"
                                            />
                                        </div>
                                        <div className="w-2/5 mx-1 mb-2">
                                            <label htmlFor="name" className="block text-sm font-medium text-gray-700">Email</label>
                                            <input
                                                type="text"
                                                id="name"
                                                name="name"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                className="border border-grey3 p-2 rounded-md w-full"
                                            />
                                        </div>
                                    </div>
                                    <div className="flex">
                                        <div className="w-1/2 mx-1 mb-2">
                                            <label htmlFor="name" className="block text-sm font-medium text-gray-700">Whatsapp Number</label>
                                            <input
                                                type="text"
                                                id="name"
                                                name="name"
                                                value={whatsapp_number}
                                                onChange={(e) => setWhatsappNumber(e.target.value)}
                                                className="border border-grey3 p-2 rounded-md w-full"
                                            />
                                        </div>
                                        <div className="w-1/2 mx-1 mb-2">
                                            <label htmlFor="name" className="block text-sm font-medium text-gray-700">Phone Number</label>
                                            <input
                                                type="text"
                                                id="name"
                                                name="name"
                                                value={phone_number}
                                                onChange={(e) => setPhoneNumber(e.target.value)}
                                                className="border border-grey3 p-2 rounded-md w-full"
                                            />
                                        </div>
                                    </div>
                                    <div className="mb-4">

                                        <label htmlFor="name" className="block text-sm font-medium text-gray-700">About</label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            value={about}
                                            onChange={(e) => setAbout(e.target.value)}
                                            className="border border-grey3 p-2 rounded-md w-full"
                                        />
                                    </div>
                                    <div className="mb-4">

                                        <label htmlFor="name" className="block text-sm font-medium text-gray-700">Address</label>
                                        <textarea
                                            id="value"
                                            name="value"
                                            value={address}
                                            onChange={(e) => setAddress(e.target.value)}
                                            className="border border-grey3 p-2 rounded-md w-full"
                                            rows="4"
                                        />
                                    </div>


                                    <div className="flex justify-end">
                                        <Link
                                            to="/admin/appsettings/list"
                                            className="text-dGrey3 py-3 bg-black2 hover:bg-blue-800 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 text-center flex items-center"
                                        >
                                            <List className="mx-2" />
                                            Back To List
                                        </Link>
                                        <button
                                            type="submit"
                                            className={`text-dGrey3 bg-darkGreen3 p-2  mx-2 rounded-md ${loading ? "cursor-not-allowed" : ""}`}
                                            disabled={loading}
                                        >
                                            {loading ? "Updating..." : "Update Setting"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
                </div>
            </MainLayouts>
        </div>
    );
};

export default UpdateAppSettings;
